import React, {Component} from 'react';
import {Dialog, Divider, Slide} from "@material-ui/core/";
import CloseIcon from '@material-ui/icons/Close';
import {Button, IconButton, TextField} from "@material-ui/core";
import strings from "../localization";
import SelectControl from '../components/controls/SelectControl';
import DatePickerControl from "../components/controls/DatePickerControl";
import {getContractTypesString} from "../constants/ContractTypes";
import {findDataValue} from "../util/DropdownUtil";
import {checkCondition} from "../util/FieldsConditionUtil";
import FormComponent from "./FormComponent";
import { getOffer, sendOffer } from '../services/OfferService';
import { getYesNoOption, getYesNoOptions } from '../constants/YesNoOptions';
import {getCurrenciesList} from "../constants/Currencies";
import {getError, hasError} from "../functions/Validation";
import {getHours} from "../constants/Hours";
import HRApprovalStatus from "../constants/HRApprovalStatus";
import {getFilteredCarAllowanceOptions, getCarAllowanceOptionByAmount} from "../constants/CarAllowanceOptions";


class MakeOfferModal extends FormComponent {

    constructor(props) {
        super(props);

        this.state = {
            data: {
                offer: {
                    rateOfPay: '',
                    annualSalary: '',
                    selectedRateId: null,
                    hoursPerWeek: '',
                    workPattern: null,
                    currency: '',
                    contractedHoursPerMonth: '',
                    carAllowance: null,
                    bonus: null,
                    commission: null,
                    healthcare: null,
                    startDate: null,
                    continuousStartDate: null,
                    unpaidBreak: '30',
                    holidayEntitlement: '',
                    rateOfPayPerHalfDay: '',
                    carAllowancePerMonth: '',
                    carAllowancePerMonthOption: null,
                    pension: '',
                    mileageRate: '',
                    additionalBenefits: ''
                },
                contractRates: []
            },
            errors: {},
            application: props.application ? props.application : undefined
        }

        this.done = this.done.bind(this);
    }
    hoursPerWeekGlbl = '0';
    rateOfPayGlbl ='0';
    componentWillReceiveProps(props) {
        this.state.application = props.application;
        if(props.application != null) {
            if(props.application.offer != null || props.application.offer != undefined) {
                this.rateOfPayGlbl = props.application.offer.rateOfPay;
                this.hoursPerWeekGlbl = props.application.offer.contractedHoursPerMonth;
                console.log('componentWillReceiveProps - Initialized hoursPerWeekGlbl:', this.hoursPerWeekGlbl);
            }
        }
        if(!this.state.application) {
            this.setState({
                data: {
                    offer: {
                        rateOfPay: '',
                        annualSalary: '',
                        selectedRateId: null,
                        hoursPerWeek: '',
                        workPattern: null,
                        currency: '',
                        contractedHoursPerMonth: '',
                        carAllowance: null,
                        bonus: null,
                        commission: null,
                        healthcare: null,
                        startDate: null,
                        continuousStartDate: null,
                        unpaidBreak: '30',
                        holidayEntitlement: '',
                        rateOfPayPerHalfDay: '',
                        carAllowancePerMonth: '',
                        carAllowancePerMonthOption: null,
                        pension: '',
                        mileageRate: '',
                        additionalBenefits: ''
                    },
                    contractRates: []
                },
                errors: {}
            });
            return;
        }

        this.fetch();
    }

    componentDidMount() {
        if(!this.state.application) {
            this.setState({
                data: {
                    offer: {
                        rateOfPay: '',
                        annualSalary: '',
                        selectedRateId: null,
                        hoursPerWeek: '',
                        workPattern: null,
                        currency: '',
                        contractedHoursPerMonth: '',
                        carAllowance: null,
                        bonus: null,
                        commission: null,
                        healthcare: null,
                        startDate: null,
                        continuousStartDate: null,
                        unpaidBreak: '30',
                        holidayEntitlement: '',
                        rateOfPayPerHalfDay: '',
                        carAllowancePerMonth: '',
                        carAllowancePerMonthOption: null,
                        pension: '',
                        mileageRate: '',
                        additionalBenefits: ''
                    },
                    contractRates: []
                }
            });
            return;
        }

        if (this.state.application?.offer?.contractedHoursPerMonth) {
            this.hoursPerWeekGlbl = typeof this.state.application.offer.contractedHoursPerMonth === 'object'
                ? this.state.application.offer.contractedHoursPerMonth.value
                : this.state.application.offer.contractedHoursPerMonth;
            console.log('componentDidMount - Initialized hoursPerWeekGlbl:', this.hoursPerWeekGlbl);
        }

        this.fetch();
    }

    fetch() {
        if(!this.state.application.id) {
            return;
        }

        getOffer(this.state.application.id).then(response => {
            if(!response || !response.ok) {
                this.setState({
                    data: {
                        offer: {
                            rateOfPay: '',
                            annualSalary: '',
                            selectedRateId: null,
                            hoursPerWeek: '',
                            workPattern: null,
                            currency: '',
                            contractedHoursPerMonth: '',
                            carAllowance: null,
                            bonus: null,
                            commission: null,
                            healthcare: null,
                            startDate: null,
                            continuousStartDate: null,
                            unpaidBreak: '30',
                            holidayEntitlement: '',
                            rateOfPayPerHalfDay: '',
                            carAllowancePerMonth: '',
                            carAllowancePerMonthOption: null,
                            pension: '',
                            mileageRate: '',
                            additionalBenefits: ''
                        },
                        contractRates: []
                    }
                });
                return;
            }

            console.log('Offer Response:', response.data);

            const offer = response.data.offer || {};
            const contractRates = response.data.contractRates || [];
            
            const startDate = offer.startDate ? new Date(offer.startDate) : null;
            const continuousStartDate = offer.continuousStartDate ? new Date(offer.continuousStartDate) : null;
            
            console.log('Parsed startDate:', startDate);

            if (offer.hoursPerWeek) {
                this.hoursPerWeekGlbl = offer.hoursPerWeek;
                console.log('Initialized hoursPerWeekGlbl:', this.hoursPerWeekGlbl);
            }

            let selectedRateId = null;
            if (offer.rateOfPay && contractRates.length > 0) {
                const matchingRate = contractRates.find(rate => rate.hourlyRate === parseFloat(offer.rateOfPay));
                if (matchingRate) {
                    selectedRateId = matchingRate.id;
                    console.log('Found matching contract rate:', matchingRate);
                }
            }

            const mappedOffer = {
                ...offer,
                workPattern: offer.workPattern ? this.props.workPatterns.find(x => x.id === offer.workPattern.id) : null,
                
                hoursPerWeek: offer.hoursPerWeek ? getHours().find(x => x.value === offer.hoursPerWeek) || getHours().find(x => x.name === offer.hoursPerWeek) : null,
                
                contractedHoursPerMonth: offer.contractedHoursPerMonth ? getHours().find(x => x.value === offer.contractedHoursPerMonth) || getHours().find(x => x.name === offer.contractedHoursPerMonth) : null,
                
                currency: offer.currency ? 
                    (typeof offer.currency === 'string' ? 
                        getCurrenciesList().find(x => x.name === offer.currency) : 
                        offer.currency) : 
                    null,
                
                carAllowance: offer.carAllowance !== undefined ? 
                    getYesNoOptions().find(x => x.value === (typeof offer.carAllowance === 'boolean' ? offer.carAllowance : offer.carAllowance?.value)) : 
                    null,
                bonus: offer.bonus !== undefined ? 
                    getYesNoOptions().find(x => x.value === (typeof offer.bonus === 'boolean' ? offer.bonus : offer.bonus?.value)) : 
                    null,
                commission: offer.commission !== undefined ? 
                    getYesNoOptions().find(x => x.value === (typeof offer.commission === 'boolean' ? offer.commission : offer.commission?.value)) : 
                    null,
                healthcare: offer.healthcare !== undefined ? 
                    getYesNoOptions().find(x => x.value === (typeof offer.healthcare === 'boolean' ? offer.healthcare : offer.healthcare?.value)) : 
                    null,
                
                startDate: startDate,
                continuousStartDate: continuousStartDate,
                
                rateOfPay: offer.rateOfPay || '',
                annualSalary: offer.annualSalary || offer.rateOfPay * offer.hoursPerWeek * 52,
                selectedRateId: selectedRateId,
                unpaidBreak: offer.unpaidBreak || '30',
                holidayEntitlement: offer.holidayEntitlement || '',
                rateOfPayPerHalfDay: offer.rateOfPayPerHalfDay || '',
                carAllowancePerMonth: offer.carAllowancePerMonth || '',
                carAllowancePerMonthOption: offer.carAllowancePerMonth ? 
                    getCarAllowanceOptionByAmount(offer.carAllowancePerMonth) : null,
                pension: offer.pension || '',
                mileageRate: offer.mileageRate || '',
                additionalBenefits: offer.additionalBenefits || ''
            };
            
            console.log('Mapped offer data:', {
                currency: mappedOffer.currency,
                carAllowance: mappedOffer.carAllowance,
                originalCurrency: offer.currency,
                originalCarAllowance: offer.carAllowance
            });
            
            this.setState({
                data: {
                    offer: mappedOffer,
                    contractRates: contractRates
                }
            }, () => {
                console.log('Updated State:', this.state.data);
            });
        });
    }
    calculateAnnualSalary() {
        const workingWeeksInYear = 52; 
        const salary =  this.rateOfPayGlbl * this.hoursPerWeekGlbl * workingWeeksInYear;
        console.log(salary);
return salary.toFixed(2);
      }
    
    
      handleRateOfPayChange = (selectedOption) => {
        console.log('handleRateOfPayChange called with:', selectedOption);
        if (!selectedOption) return;
        
        const selectedId = selectedOption.value.contractRateId;
        const originalRate = this.state.data.contractRates.find(rate => rate.id === selectedId);
        
        console.log('Selected rate:', originalRate);
        console.log('Current state:', this.state.data.offer);
        console.log('Current hoursPerWeekGlbl:', this.hoursPerWeekGlbl);
        
        if (originalRate) {
            let hoursPerWeek = this.state.data.offer.hoursPerWeek;
            console.log('Hours per week from state:', hoursPerWeek);
            
            if (!hoursPerWeek && this.hoursPerWeekGlbl) {
                hoursPerWeek = this.hoursPerWeekGlbl;
                console.log('Using hoursPerWeekGlbl:', hoursPerWeek);
            }
            
            console.log('Final hours per week value:', hoursPerWeek);
            
            const annualSalary = hoursPerWeek.value && parseFloat(hoursPerWeek.value) > 0
                ? (originalRate.hourlyRate * parseFloat(hoursPerWeek.value) * 52).toFixed(2)
                : null;
            
            console.log('Calculated annual salary:', annualSalary);
            
            this.setState(prevState => ({
                data: {
                    ...prevState.data,
                    offer: {
                        ...prevState.data.offer,
                        rateOfPay: originalRate.hourlyRate.toString(),
                        selectedRateId: originalRate.id,
                        annualSalary: annualSalary
                    }
                }
            }), () => {
                console.log('State after update:', this.state.data.offer);
            });
        }
    }
    getCurrencySymbol = () => {
    const currency = this.state.data.offer.currency;
    return (currency && currency.name) ? currency.name : '£';
};  
    getContractRatesList = () => {
        if (!Array.isArray(this.state.data.contractRates)) {
            return [];
        }
        const symbol = this.getCurrencySymbol();
        return this.state.data.contractRates.map(rate => {
            return {
                value: rate.id, 
                name: `${symbol}${rate.hourlyRate.toFixed(2)} per hour - ${rate.jobRole}`,
                hourlyRate: rate.hourlyRate, 
                contractRateId: rate.id 
            };
        });
    };

    shouldShowRateOfPayDropdown = () => {
        
        const hasContractRates = Array.isArray(this.state.data.contractRates) && this.state.data.contractRates.length > 0;
        console.log('Should show rate of pay dropdown:', hasContractRates);
        return hasContractRates;
    }

    /**
     * Get filtered car allowance options based on contract type and nationality
     * @returns {Array} Filtered car allowance options
     */
    getAvailableCarAllowanceOptions = () => {
        if (!this.state.application) {
            return [];
        }

        const contractType = this.state.application.contractType;
        const nationalityId = this.state.application.nationality?.id || null;

        console.log('Getting car allowance options for:', {
            contractType,
            nationalityId,
            nationality: this.state.application.nationality
        });

        return getFilteredCarAllowanceOptions(contractType, nationalityId);
    }

    handleHoursPerWeekChange = (selectedOption) => {
        console.log('Hours per week change event:', selectedOption);
        
        if (!selectedOption) return;

        // SelectControl passes { value: { value, name }, label, target } — persist the hours option only
        const hoursOption = selectedOption.value && selectedOption.value.value !== undefined
            ? selectedOption.value
            : selectedOption;
        
        console.log('Selected hours per week:', hoursOption);
        
        const rateOfPay = this.state.data.offer.rateOfPay || 0;
        
        this.hoursPerWeekGlbl = hoursOption;
        
        
        const annualSalary = (rateOfPay && hoursOption && parseFloat(hoursOption.value) > 0)
            ? (parseFloat(rateOfPay) * parseFloat(hoursOption.value) * 52).toFixed(2)
            : null;

        console.log('Calculated annual salary:', annualSalary);

        this.setState(prevState => ({
            data: {
                ...prevState.data,
                offer: {
                    ...prevState.data.offer,
                    hoursPerWeek: hoursOption,
                    contractedHoursPerMonth: hoursOption,
                    annualSalary: annualSalary
                }
            }
        }), () => {
            console.log('State after update:', this.state.data.offer);
        });
    };

    validateSalary(value) {

        if(!value) {
            return true;
        }

        const re = new RegExp('^\\d+(\\.\\d{1,2})?$');

        return re.test(value) && value.length < 10;
    }

    done() {
        let hasError = false;
        let errors = this.state.errors;

        if(!this.validateSalary(this.state.data.offer.annualSalary)) {
            hasError = true;
            errors['offer.annualSalary'] = [{message: 'You can only enter up to 6 digits plus two decimal places.'}]

            this.setState({
                errors: errors
            });
        }

        if(!this.validateSalary(this.state.data.carAllowancePerMonth)) {
            hasError = true;
            errors['carAllowancePerMonth'] = [{message: 'You can only enter up to 6 digits plus two decimal places.'}]

            this.setState({
                errors: errors
            });
        }

        if(hasError) {
            return;
        }

        this.setState({
            errors: {}
        });

        const workPattern = this.state.data.offer.workPattern;
        const resolveHoursValue = (hours) => {
            if (hours == null || hours === '') {
                return '';
            }
            if (typeof hours === 'object') {
                // Prefer nested select option { value: { value, name } } then { value, name }
                if (hours.value != null && typeof hours.value === 'object' && hours.value.value != null) {
                    return String(hours.value.value);
                }
                if (hours.value != null && hours.value !== '') {
                    return String(hours.value);
                }
                if (hours.name != null && hours.name !== '') {
                    return String(hours.name);
                }
                return '';
            }
            return String(hours);
        };
        // For Hourly, UI binds hours into hoursPerWeek; keep contractedHoursPerMonth in sync
        const hoursPerWeek = resolveHoursValue(this.state.data.offer.hoursPerWeek);
        const contractedHoursPerMonth = resolveHoursValue(
            this.state.data.offer.contractedHoursPerMonth || this.state.data.offer.hoursPerWeek
        );
        const currency = this.state.data.offer.currency;
        const carAllowance = this.state.data.offer.carAllowance;
        const bonus = this.state.data.offer.bonus;
        const commission = this.state.data.offer.commission;
        const healthcare = this.state.data.offer.healthcare;

        console.log('Dropdown values:', {
            workPattern,
            hoursPerWeek,
            contractedHoursPerMonth,
            currency,
            carAllowance,
            bonus,
            commission,
            healthcare
        });

        const offerData = {
            ...this.state.data.offer,

            id: this.state.data.offer.id || 0,
            dateCreated: this.state.data.offer.dateCreated || new Date(),
            dateUpdated: new Date(),
            deleted: false,

            applicationId: this.state.application.id,

            workPattern: workPattern,

            hoursPerWeek: hoursPerWeek,
            contractedHoursPerMonth: contractedHoursPerMonth,

            currency: currency?.name || currency || '',

            carAllowance: carAllowance?.value === true,
            bonus: bonus?.value === true,
            commission: commission?.value === true,
            healthcare: healthcare?.value === true,

            startDate: this.state.data.offer.startDate || new Date(),
            continuousStartDate: this.state.data.offer.continuousStartDate || new Date(),

            rateOfPay: this.state.data.offer.rateOfPay?.toString() || '',
            annualSalary: this.state.data.offer.annualSalary?.toString() || '',
            carAllowancePerMonth: this.state.data.offer.carAllowancePerMonthOption?.amount?.toString() || 
                                  this.state.data.offer.carAllowancePerMonth?.toString() || '',
            mileageRate: this.state.data.offer.mileageRate?.toString() || '',
            pension: this.state.data.offer.pension?.toString() || '',
            rateOfPayPerHalfDay: this.state.data.offer.rateOfPayPerHalfDay?.toString() || '',
            holidayEntitlement: this.state.data.offer.holidayEntitlement?.toString() || '',
            unpaidBreak: this.state.data.offer.unpaidBreak?.toString() || '30',
            additionalBenefits: this.state.data.offer.additionalBenefits?.toString() || '',

            hrApprovalStatus: this.state.data.offer.hrApprovalStatus || 0,
            hrApprovalComment: this.state.data.offer.hrApprovalComment || '',

            selectedRateId: this.state.data.offer.selectedRateId
        };

        Object.keys(offerData).forEach(key => {
            if (offerData[key] === undefined || offerData[key] === null) {
                delete offerData[key];
            }
        });

        console.log('Complete offer data being sent:', {
            offerData,
            originalState: this.state.data.offer
        });

        sendOffer(this.state.application.id, offerData).then(response => {
            if(!response || !response.ok) {
                return;
            }

            this.props.toggleModal();
        });
    }

    Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="left" ref={ref} {...props} />;
    });

    componentDidUpdate(prevProps, prevState, snapshot) {

        if(prevProps.selectedItem !== this.props.selectedItem){
            this.setState({
                data: this.props.selectedItem
            });
        }

        if(this.props.contractType){
            const data = this.state.data;
            data.contractType = this.props.contractType;

            if(prevProps.contractType !== this.props.contractType){
                this.setState({
                    data: data
                });
            }
        }
    }

    handleManualRateOfPayChange = (event) => {
        console.log('handleManualRateOfPayChange called with:', event.target.value);
        const value = event.target.value;
        
        let hoursPerWeek = this.state.data.offer.hoursPerWeek?.value || this.state.data.offer.contractedHoursPerMonth?.value;
        console.log('Hours per week from state:', hoursPerWeek);
        
        if (!hoursPerWeek && this.hoursPerWeekGlbl) {
            hoursPerWeek = this.hoursPerWeekGlbl;
            console.log('Using hoursPerWeekGlbl:', hoursPerWeek);
        }
        
        console.log('Final hours per week value:', hoursPerWeek);
        
        const annualSalary = (value && hoursPerWeek && !isNaN(hoursPerWeek) && parseFloat(hoursPerWeek) > 0)
            ? (parseFloat(value) * parseFloat(hoursPerWeek) * 52).toFixed(2)
            : null;

        console.log('Calculated annual salary:', annualSalary);

        this.setState(prevState => ({
            data: {
                ...prevState.data,
                offer: {
                    ...prevState.data.offer,
                    rateOfPay: value,
                    annualSalary: annualSalary,
                    selectedRateId: null
                }
            }
        }), () => {
            console.log('State after manual rate update:', this.state.data.offer);
        });
    }

    changeData = (event) => {
        const { name, value } = event.target;
        console.log('changeData called with:', { name, value });

        this.setState(prevState => {
            const newState = {
                ...prevState,
                data: {
                    ...prevState.data,
                    offer: {
                        ...prevState.data.offer
                    }
                }
            };

            if (name === 'workPattern' || name === 'hoursPerWeek' || 
                name === 'contractedHoursPerMonth' || name === 'currency' || 
                name === 'carAllowance' || name === 'bonus' || 
                name === 'commission' || name === 'healthcare' || 
                name === 'carAllowancePerMonthOption') {
                
                console.log(`Updating ${name} dropdown:`, value);
                newState.data.offer[name] = value;

                // If car allowance option is selected, update the carAllowancePerMonth field
                if (name === 'carAllowancePerMonthOption' && value) {
                    newState.data.offer.carAllowancePerMonth = value.amount.toString();
                    console.log('Updated carAllowancePerMonth to:', value.amount);
                }

                if (name === 'hoursPerWeek' || name === 'contractedHoursPerMonth') {
                    const hoursPerWeek = value?.value || value;
                    const rateOfPay = prevState.data.offer.rateOfPay || 0;
                    
                    console.log('Hours per week value:', hoursPerWeek);
                    console.log('Rate of pay:', rateOfPay);
                    
                    if (hoursPerWeek && rateOfPay) {
                        const annualSalary = (parseFloat(rateOfPay) * parseFloat(hoursPerWeek) * 52).toFixed(2);
                        newState.data.offer.annualSalary = annualSalary;
                        console.log('Recalculated annual salary:', annualSalary);
                    }

                    if (name === 'hoursPerWeek') {
                        this.hoursPerWeekGlbl = hoursPerWeek;
                        console.log('Updated hoursPerWeekGlbl:', this.hoursPerWeekGlbl);
                    }
                }
            }
            else if (name === 'startDate' || name === 'continuousStartDate') {
                console.log('Updating date:', { name, value });
                newState.data.offer[name] = value;
            }
            else {
                newState.data.offer[name] = value;
            }

            return newState;
        }, () => {
            console.log('State after update:', this.state.data);
        });
    }

    render() {
        return (
            <Dialog
                onClose={this.props.toggleModal}
                aria-labelledby="customized-dialog-title"
                open={this.props.open}
                TransitionComponent={this.Transition}
                className={'make-offer-modal'}
                PaperProps={{
                    style: {
                        maxHeight: '95vh',
                        overflowY: 'auto'
                    }
                }}
            >
                <div className='form-modal-header' onClose={this.props.toggleModal}>
                    <div>
                        <h1>{this.props.title}</h1>
                        <IconButton className={'close-button-wrapper'} onClick={this.props.toggleModal}>
                            <CloseIcon/>
                        </IconButton>
                    </div>
                    <Divider />
                    <div className={'make-offer-wrapper'} style={{ paddingBottom: '20px' }}>
                        <div className={'content-wrapper'} style={{ paddingBottom: '20px' }}>
                            <div className={'left-wrapper'}>
                                <div className={'first-name left'}>
                                    <label>{strings.makeOffer.firstName}</label>
                                    <div className={'inner-left'}>
                                        {this.state.application ? this.state.application.forename : ""}
                                    </div>
                                </div>
                                <div className={'division left'}>
                                    <label>{strings.makeOffer.division}</label>
                                    <div className={'inner-left'}>
                                        {
                                            this.state.application &&
                                            findDataValue(this.state.application, 'division')
                                        }
                                    </div>
                                </div>
                                <div className={'contract-type left'}>
                                    <label>{strings.makeOffer.jobRole}</label>
                                    <div className={'inner-left'}>
                                        {
                                            this.state.application &&
                                            findDataValue(this.state.application, 'jobRole') ? findDataValue(this.state.application, 'jobRole') : this.state.application?.jobRoleText
                                        }
                                    </div>
                                </div>
                                {
                                    checkCondition(this.state.application, 'workPattern') &&
                                    <div className={'work-pattern left'}>
                                        <label>{strings.makeOffer.workPattern}</label>
                                        <SelectControl
                                            isDisabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                            isSearchable={false}
                                            placeholder={strings.makeOffer.workPattern}
                                            options={this.props.workPatterns}
                                            fullWidth
                                            autoFocus
                                            name='workPattern'
                                            onChange={this.changeData}
                                            margin="normal"
                                            value={this.state.data.offer.workPattern}
                                            nameKey={'name'}
                                            valueKey={'id'}
                                            selected={this.state.data.offer.workPattern}
                                        />
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'hoursPerWeek') &&
                                    <div className={'hours-per-week left'}>
                                        <label>{strings.makeOffer.hoursPerWeek}</label>
                                        <SelectControl
                                            isDisabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                            isSearchable={false}
                                            placeholder={strings.makeOffer.hoursPerWeek}
                                            options={getHours()}
                                            fullWidth
                                            autoFocus
                                            name='hoursPerWeek'
                                            onChange={this.changeData}
                                            margin="normal"
                                            value={this.state.data.offer.hoursPerWeek}
                                            nameKey={'name'}
                                            valueKey={'value'}
                                            selected={this.state.data.offer.hoursPerWeek}
                                        />
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'mileageRate') &&
                                    <div className={'mileage-rate left'}>
                                        <label>{strings.makeOffer.mileageRate}</label>
                                        <TextField
                                            fullWidth
                                            name='mileageRate'
                                            onChange={this.changeData}
                                            margin="none"
                                            value={this.state.data.offer.mileageRate || ''}
                                            variant={"outlined"}
                                            disabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                        />
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'contractedHoursPerMonth') &&
                                    <div className={'mileage-rate left'}>
                                        <label>{strings.makeOffer.contractedHoursPerMonth}</label>
                                        <SelectControl
                                            isDisabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                            isSearchable={false}
                                            placeholder={strings.makeOffer.contractedHoursPerMonth}
                                            options={getHours()}
                                            fullWidth
                                            autoFocus
                                            name='contractedHoursPerMonth'
                                            onChange={this.handleHoursPerWeekChange}
                                            margin="normal"
                                            value={this.state.data.offer.hoursPerWeek}
                                            nameKey={'name'}
                                            valueKey={'value'}
                                            selected={this.state.data.offer.hoursPerWeek}
                                        />
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'healthcare') &&
                                    <div className={'healthcare left'}>
                                        <label>{strings.makeOffer.healthcare}</label>
                                        <SelectControl
                                            isSearchable={false}
                                            placeholder={ strings.makeOffer.healthcare }
                                            options={this.props.healthcare}
                                            fullWidth
                                            autoFocus
                                            name='healthcare'
                                            onChange={ this.changeData }
                                            margin="normal"
                                            value={ this.state.data.healthcare }
                                            nameKey={ 'name' }
                                            valueKey={ 'value' }
                                            selected={ this.state.data.healthcare }
                                            isDisabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                        />
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'unpaidBreak') &&
                                    <div className={'car-allowance left'}>
                                        <label>{strings.makeOffer.unpaidBreak}</label>
                                        <TextField
                                            fullWidth
                                            name='unpaidBreak'
                                            onChange={ this.changeData }
                                            margin="none"
                                            value={this.state.data.unpaidBreak !== undefined && this.state.data.unpaidBreak !== '' 
                                                ? this.state.data.unpaidBreak 
                                                : 30}
                                            variant={"outlined"}
                                            disabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                        />
                                    </div>
                                }
                                {/* {
                                    checkCondition(this.state.application, 'additionalBenefits') &&
                                    <div className={'car-allowance left'}>
                                        <label>{strings.makeOffer.additionalBenefits}</label>
                                        <TextField
                                            fullWidth
                                            name='additionalBenefits'
                                            onChange={ this.changeData }
                                            margin="none"
                                            value={ this.state.data.additionalBenefits }
                                            variant={"outlined"}
                                        />
                                    </div>
                                } */}
                            </div>
                            <div className={'right-wrapper'}>
                                <div className={'surname right'}>
                                    <label>{strings.makeOffer.surname}</label>
                                    <div className={'inner-right'}>
                                        {this.state.application ? this.state.application.surname : ''}
                                    </div>
                                </div>
                                {
                                    checkCondition(this.state.application, 'region') &&
                                    <div className={'region right'}>
                                        <label>{strings.makeOffer.region}</label>
                                        <div className={'inner-right'}>
                                            {
                                                this.state.application &&
                                                findDataValue(this.state.application, 'region')
                                            }
                                        </div>
                                    </div>
                                }
                                <div className={'contract-type right'}>
                                    <label>{strings.makeOffer.contractType}</label>
                                    <div className={'inner-right'}>
                                        {
                                            this.state.application &&
                                            getContractTypesString(this.state.application.contractType)
                                        }
                                    </div>
                                </div>
                                {
                                    checkCondition(this.state.application, 'startDate') &&
                                    <div className={'start-date right'}>
                                        <label>{strings.makeOffer.startDate}</label>
                                        <div className={'inner-right'}>
                                            <DatePickerControl
                                                dateFormat='dd/MM/yyyy'
                                                date={this.state.data.offer.startDate}
                                                name={'startDate'}
                                                placeholder={strings.makeOffer.pleaseSelect}
                                                onChange={this.changeData}
                                                withPortal={true}
                                                disabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                            />
                                        </div>
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'continuousStartDate') &&
                                    <div className={'start-date right'}>
                                        <label>{strings.makeOffer.continuousStartDate}</label>
                                        <div className={'inner-right'}>
                                            <DatePickerControl
                                                dateFormat='dd/MM/yyyy'
                                                date={this.state.data.offer.continuousStartDate}
                                                name={'continuousStartDate'}
                                                placeholder={strings.makeOffer.pleaseSelect}
                                                onChange={this.changeData}
                                                withPortal={true}
                                                disabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                            />
                                        </div>
                                    </div>
                                }
                                <div className={'carAllowance right'}>
                                    <label>{strings.makeOffer.currency}</label>
                                    <SelectControl
                                        isDisabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                        isSearchable={false}
                                        placeholder={strings.makeOffer.currency}
                                        options={getCurrenciesList()}
                                        fullWidth
                                        autoFocus
                                        name='currency'
                                        onChange={this.changeData}
                                        margin="normal"
                                        value={this.state.data.offer.currency}
                                        nameKey={'name'}
                                        valueKey={'value'}
                                        selected={this.state.data.offer.currency}
                                    />
                                </div>
                                {
                                    checkCondition(this.state.application, 'rateOfPay') &&
                                    <div className={'rate-of-pay right'}>
                                        <label>{strings.makeOffer.rateOfPay}</label>
                                        {
                                            this.shouldShowRateOfPayDropdown() ? (
                                                <SelectControl
                                                    isSearchable={false}
                                                    placeholder={strings.makeOffer.rateOfPay}
                                                    options={this.getContractRatesList()}
                                                    fullWidth
                                                    autoFocus
                                                    name='rateOfPay'
                                                    onChange={this.handleRateOfPayChange}
                                                    margin="normal"
                                                    value={this.state.data.offer.selectedRateId && this.getContractRatesList().length > 0 ?
                                                        this.getContractRatesList().find(x => x.contractRateId === this.state.data.offer.selectedRateId) : null
                                                    }
                                                    nameKey={'name'}
                                                    valueKey={'value'}
                                                    selected={
                                                        this.state.data.offer.rateOfPay && 
                                                        !isNaN(this.state.data.offer.rateOfPay) && 
                                                        this.getContractRatesList().some(rate => rate.hourlyRate === parseFloat(this.state.data.offer.rateOfPay)) ?
                                                            this.getContractRatesList().find(rate => rate.hourlyRate === parseFloat(this.state.data.offer.rateOfPay)) :
                                                            null
                                                    }
                                                />
                                            ) : (
                                                <TextField
                                                    fullWidth
                                                    name='rateOfPay'
                                                    onChange={this.handleManualRateOfPayChange}
                                                    margin="none"
                                                    value={this.state.data.offer.rateOfPay || ''}
                                                    variant={"outlined"}
                                                    disabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                                    type="number"
                                                    inputProps={{ step: "0.01" }}
                                                />
                                            )
                                        }
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'annualSalary') &&
                                    <div className={'annual-salary right'}>
                                        <label>{strings.makeOffer.annualSalary}</label>
                                        <TextField
                                            disabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                            error={hasError(this.state.errors, 'offer.annualSalary')}
                                            helperText={getError(this.state.errors, 'offer.annualSalary')}
                                            fullWidth
                                            name='offer.annualSalary'
                                            onChange={this.changeData}
                                            margin="none"
                                            value={this.state.data.offer.annualSalary || ''}
                                            variant={"outlined"}
                                        />
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'carAllowanceSelect', this.state.data) &&
                                    <div className={'carAllowance right'}>
                                        <label>{strings.makeOffer.carAllowance}</label>
                                        <SelectControl
                                            isDisabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                            isSearchable={false}
                                            placeholder={ strings.makeOffer.carAllowance }
                                            options={getYesNoOptions()}
                                            fullWidth
                                            autoFocus
                                            name='carAllowance'
                                            onChange={ this.changeData }
                                            margin="normal"
                                            value={ this.state.data.offer.carAllowance }
                                            nameKey={ 'name' }
                                            valueKey={ 'value' }
                                            selected={ this.state.data.offer.carAllowance }
                                        />
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'carAllowancePerMonth', this.state.data.offer) &&
                                    <div className={'car-allowance-per-month right'}>
                                        <label>{strings.makeOffer.carAllowancePerMonth}</label>
                                        <SelectControl
                                            isDisabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                            isSearchable={false}
                                            placeholder={strings.makeOffer.carAllowancePerMonth}
                                            options={this.getAvailableCarAllowanceOptions()}
                                            fullWidth
                                            autoFocus
                                            name='carAllowancePerMonthOption'
                                            onChange={this.changeData}
                                            margin="normal"
                                            value={this.state.data.offer.carAllowancePerMonthOption}
                                            nameKey={'name'}
                                            valueKey={'value'}
                                            selected={this.state.data.offer.carAllowancePerMonthOption}
                                        />
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'holidayEntitlement') &&
                                    <div className={'car-allowance right'}>
                                        <label>{strings.makeOffer.holidayEntitlement}</label>
                                        <TextField
                                            disabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                            fullWidth
                                            name='holidayEntitlement'
                                            onChange={ this.changeData }
                                            margin="none"
                                            value={ this.state.data.holidayEntitlement }
                                            variant={"outlined"}
                                        />
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'pension') &&
                                    <div className={'pension right'}>
                                        <label>{strings.makeOffer.pension}</label>
                                        <TextField
                                            disabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                            fullWidth
                                            name='pension'
                                            onChange={ this.changeData }
                                            margin="none"
                                            value={ this.state.data.pension }
                                            variant={"outlined"}
                                        />
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'rateOfPayPerHalfDay') &&
                                    <div className={'pension right'}>
                                        <label>{strings.makeOffer.rateOfPayPerHalfDay}</label>
                                        <TextField
                                            disabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                            fullWidth
                                            name='rateOfPayPerHalfDay'
                                            onChange={ this.changeData }
                                            margin="none"
                                            value={ this.state.data.rateOfPayPerHalfDay }
                                            variant={"outlined"}
                                        />
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'bonus') &&
                                    <div className={'carAllowance right'}>
                                        <label>{strings.makeOffer.bonus}</label>
                                        <SelectControl
                                            isDisabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                            isSearchable={false}
                                            placeholder={ strings.makeOffer.bonus }
                                            options={getYesNoOptions()}
                                            fullWidth
                                            autoFocus
                                            name='bonus'
                                            onChange={ this.changeData }
                                            margin="normal"
                                            value={ this.state.data.bonus }
                                            nameKey={ 'name' }
                                            valueKey={ 'value' }
                                            selected={ this.state.data.bonus }
                                        />
                                    </div>
                                }
                                {
                                    checkCondition(this.state.application, 'commission') &&
                                    <div className={'carAllowance right'}>
                                        <label>{strings.makeOffer.commission}</label>
                                        <SelectControl
                                            isSearchable={false}
                                            placeholder={ strings.makeOffer.commission }
                                            options={getYesNoOptions()}
                                            fullWidth
                                            autoFocus
                                            name='commission'
                                            onChange={ this.changeData }
                                            margin="normal"
                                            value={ this.state.data.commission }
                                            nameKey={ 'name' }
                                            valueKey={ 'value' }
                                            selected={ this.state.data.commission }
                                            isDisabled={this.state.application?.offer?.hrApprovalStatus === HRApprovalStatus.WAITING_APPROVAL}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                        <Button className={'make-offer-button'} variant="contained" color="primary" onClick={ this.done}>
                            { strings.makeOffer.done }
                        </Button>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default MakeOfferModal;